import { connect } from 'react-redux';
import { changeDate } from '../actions/index';
// Components
import Dates from '../components/layout/nav/dates/Dates';


const days = [23, 24, 25];

const mapStateToProps = (state) => {
  return {
    activeDay: state.dateSelector,
    days,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onDateChange: (newdate) => {
      dispatch(changeDate(newdate));
    },
  };
};

const DatesContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(Dates);

export default DatesContainer;



/** WEBPACK FOOTER **
 ** ./src/containers/DateContainer.js
 **/